import { bem } from '~/common/classname';
import type { RecordType } from '~/highlight/types/record';
import './styles.scss';

type Props = {
  target: HTMLElement;
  list: RecordType[];
  selectedRecord: RecordType;
  onClick: (id: number) => void;
};

type StateType = {
  selectedRecord?: RecordType;
};

class PlayList {
  props: Props;
  state: StateType;
  onClick: (event: MouseEvent) => void;

  constructor(props: Props) {
    this.props = props;
    this.state = { selectedRecord: this.props.selectedRecord };
    this.onClick = this.handleClick.bind(this);
    this.render();
  }

  template() {
    const { list } = this.props;
    const { selectedRecord } = this.state;
    return /*html*/ `
      <ol class="${bem(['bai-highlight-modal', 'playlist'])}">
        ${list
          .map((record) => {
            const { id, subject } = record;
            const active = id === selectedRecord?.id;
            const liClassname = bem([
              'bai-highlight-modal',
              'playlist',
              'item',
            ]);
            return /*html*/ `
              <li class="${liClassname} ${
              active ? bem([liClassname, 'active'], true) : ''
            }" data-item-id="${id}">
                <div role="button">${subject}</div>
              </li>
            `;
          })
          .join('')}
      </ol>
    `;
  }

  replaceActiveLi() {
    const liClassname = bem(['bai-highlight-modal', 'playlist', 'item']);
    const liList = document.querySelectorAll(`.${liClassname}`);
    if (!liList.length) return;

    const { selectedRecord } = this.state;
    liList.forEach((li) => {
      const { classList } = li;
      const id = li.getAttribute(`data-item-id`);
      if (!id) return;

      const activeClassname = bem([liClassname, 'active'], true);
      if (+id === selectedRecord?.id) {
        classList.add(activeClassname);
      } else {
        classList.remove(activeClassname);
      }
    });
  }

  render() {
    const ol = document.querySelector<HTMLOListElement>(
      `.${bem(['bai-highlight-modal', 'playlist'])}`
    );

    if (ol) {
      this.replaceActiveLi();
    } else {
      this.props.target.insertAdjacentHTML('afterbegin', this.template());
    }
    this.setup();
    this.scrollOList();
  }

  setup() {
    const liList = document.querySelectorAll(
      `.${bem(['bai-highlight-modal', 'playlist', 'item'])}`
    );
    if (liList.length) {
      liList.forEach((li) => {
        li.addEventListener('click', this.onClick);
      });
    }
  }

  setState(newState: StateType) {
    this.state = { ...this.state, ...newState };
    this.render();
  }

  handleClick(event: MouseEvent) {
    const id = (event.currentTarget as HTMLElement).getAttribute(
      'data-item-id'
    );
    if (id) {
      this.props.onClick(+id);
      this.setState({
        selectedRecord: this.props.list.find((record) => record.id === +id),
      });
    }
  }

  getScrollX(element: HTMLElement) {
    return element.scrollLeft;
  }

  scrollOList() {
    const activeLi = document.querySelector<HTMLLIElement>(
      `.${bem(['bai-highlight-modal', 'playlist', 'item'])}--active`
    );
    if (!activeLi) return;

    activeLi.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
  }
}

export default PlayList;
